import { cva } from "class-variance-authority";

export const CARD_STYLES = {
  header: "flex flex-col space-y-1.5 p-6",
  title: "font-semibold leading-none tracking-tight",
  description: "text-sm text-muted-foreground",
  content: "p-6 pt-0",
  footer: "flex items-center p-6 pt-0",
} as const;

export const cardVariants = cva(
  "rounded-xl border bg-card text-card-foreground shadow",
  {
    variants: {
      variant: {
        default: "",
        interactive:
          "cursor-pointer transition-all hover:shadow-lg hover:border-gray-300",
        selected:
          "cursor-pointer transition-all hover:shadow-lg border-2 border-primary bg-blue-50",
        elevated: "shadow-lg",
        recentSearch:
          "group cursor-pointer transition-shadow hover:shadow-md bg-ticketon-card-bg border-transparent",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export const cardContentVariants = cva("p-6 pt-0", {
  variants: {
    variant: {
      default: "",
      centered: "flex flex-col items-center justify-center text-center",
      datePrice:
        "flex flex-col items-center justify-center text-center h-full min-h-[70px]",
      recentSearch: "flex items-center h-full p-5",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
